<div class="app-dialog">
  <h2>{{ title }}</h2>
  <p class="mt20">{{ message }}</p>
  <div class="mtb20" style="font-size: 14px" *ngIf="showDisableMe">
    <mat-checkbox [(ngModel)]="disableMe"><span translate>Non mostrare più</span></mat-checkbox>
  </div>
  <div class="yes-no">
    <button mat-flat-button color="primary" (click)="closeDialog(false)" mat-button>
      <span translate>COMMONS.NO</span>
    </button>
    <button mat-flat-button color="primary" (click)="closeDialog(true)" mat-button>
      <span translate>COMMONS.YES</span>
    </button>
  </div>
</div>